import { Injectable } from '@angular/core';
// import Web3 from 'web3';
// import Portis from "@portis/web3";
// import CoinbaseWalletSDK from "@coinbase/wallet-sdk";
// import { CoinGeckoClient } from 'coingecko-api-v3';
// import Authereum from "authereum";
// import WalletLink from "walletlink";
// import Torus from "@toruslabs/torus-embed";

// import Web3Modal from 'web3modal';
// import WalletConnectProvider from '@walletconnect/web3-provider';
import { environment } from '../../environments/environment';
import {interval, Observable, Subject, Subscription, throwError, timer} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { NavbarService } from './navbar.service';
import { DialogService } from './dialog.service';
import {catchError, delay, delayWhen, map, retryWhen, scan, takeWhile, tap} from 'rxjs/operators';
import {RecaptchaEnterpriseService} from './recaptcha-enterprise.service';

// declare let Authereum: any;
// declare let Web3Modal;
declare let Web3: any;
declare const window: any;
declare let WalletConnectProvider: any;

@Injectable({
  providedIn: 'root'
})
export class WalletConnectService {

  private web3: any;
  private shadowWeb3Wss: any;
  private shadowWeb3Http: any;
  private provider: any;
  // private accounts: any;
  private providerOptions: any;
  public hasProvider: boolean = false;
  public transactionConfirmationBlocks: number;

  private isLocal: boolean = environment.getin_base_url == 'https://localhost:4200';
  private walletProjectId = environment.walletconnect.projectId;
  private walletInfuraId = environment.walletconnect.infuraId;
  private fortmaticKey = environment.fortmatic.prodKey;
  private portisId = environment.portis.portisId;
  private api_base_url = environment.api_base_url;
  public getinWallet = environment.getinWallet.main;
  private web3Modal;

  private Web3Modal: any;
  private Fortmatic: any;
  private evmChains: any;

  private timerSubscription: Subscription[] = [];
  public transactionSubscription: Subscription[] = [];
  private tratsactionPending: any;

  private otpWalletAddress: string;
  private otpProvider: any;
  private otpWeb3provider: any;
  private walletIsChecked = false;

  defaultGasPrice: any;
  estimatedGas: any;
  defaultNonce: any;
  accountBalance: any | null;
  priceInUsd: any;
  selectedAccount: any | null;
  selectedAddress: any | null;
  walletAddress: any | null
  cryptoPrice: any | null;
  pendingTransaction: any = {};
  user_id: any = 0;
  eventCurrency: any;
  networkIds: any[] = [];
  prevStates: any[] = [];
  networkIdName: string = '';
  networkName: string = '';
  bigNumber;
  // coinGeckoClient: any;

  private refreshTimer = new Subject<any>();
  timerStatus = this.refreshTimer.asObservable();
  private checkTransactionStatus = new Subject<any>();
  transactionStatus = this.checkTransactionStatus.asObservable();
  // private fetchAccounts = new Subject<any>();
  // fetchAccount = this.fetchAccounts.asObservable();
  private fetchAccountDataStatus = new Subject<any>();
  fetchAccountStatus = this.fetchAccountDataStatus.asObservable();
  private refreshAccountDataStatus = new Subject<any>();
  refreshAccountStatus = this.refreshAccountDataStatus.asObservable();
  private walletSessionStatus = new Subject<any>();
  getWalletSessionStatus = this.walletSessionStatus.asObservable();
  private walleChainError = new Subject<any>();
  getwalleChainError = this.walleChainError.asObservable();
  private walletConnectUser = new Subject<any>();
  getWalletConnectUser = this.walletConnectUser.asObservable();
  private walletUnConnect = new Subject<any>();
  getUnConnectWallet = this.walletUnConnect.asObservable();

  public NftScanParticipantSubscription: Subscription[] = [];
  private NftScanParticipantData = new Subject<any>();
  getNftScanParticipantData = this.NftScanParticipantData.asObservable();

  constructor(private http: HttpClient,
              public authService: AuthService,
              private nav: NavbarService,
              private dialogService: DialogService,
              private recaptchaService: RecaptchaEnterpriseService) {
    window.Web3 ? Web3 = window.Web3 : console.log('Please check internet connection!');
    window.Web3Modal && window.Web3Modal.default ? this.Web3Modal = window.Web3Modal.default : console.log('Please check internet connection!');
    window.Fortmatic ? this.Fortmatic = window.Fortmatic : console.log('Please check internet connection!');
    window.evmChains ? this.evmChains = window.evmChains : console.log('Please check internet connection!');
    window.WalletConnectProvider && window.WalletConnectProvider.default ? WalletConnectProvider = window.WalletConnectProvider.default : console.log('Please check internet connection!');
    // this.user_id = this.authService.getUser();
    // console.log("Initializing...");
    // console.log("window.web3 is", window.web3, "window.ethereum is", window.ethereum);
    this.setProviderOptions();
    this.nav.currentUserId.subscribe(user_id => {
      //console.log('detectWeb3Provider', this.user_id);
      // if (this.user_id !== 0) {this.detectWeb3Provider(); }
      this.user_id = user_id;
      // console.log(`The new user is authorized, ${this.user_id} the service will be restarted.`);
      // environment.production ? this.detectWeb3Provider() : this.detectWeb3Provider();
      const mainNetworks = [{'1': 'ethereum'}, {'137': 'matic-network'}, {'250': 'fantom'}, {'100': 'xdai'}, {'56': 'binancecoin'}];
      // TODO: for check main network, testnet, chain and their currencies // {'02':'wrapped-bitcoin'}, {'btc': 'bitcoin'}
      const localNetworks = [{'97': 'binancecoin'}, {'5': 'ethereum'}, {'4': 'ethereum'}, {'42': 'ethereum'}, {'3': 'ethereum'}];
      // if (user_id && user_id !== 0) {
      //   this.user_id = user_id;
      //   environment.production ? this.detectWeb3Provider() : this.detectWeb3Provider();
      //   console.log(`The new user is authorized, ${this.user_id} the service will be restarted.`);
      // }
      this.isLocal || this.user_id == 178 || environment.getin_base_url === 'https://getin-nextgen.com'  ? this.networkIds = [...mainNetworks, ...localNetworks] : this.networkIds = [...mainNetworks];
      // console.log('networkIds: ', this.isLocal, this.networkIds);
    });
  }

  detectWeb3Provider() {
    if (Web3) {
      // console.log('Web3 Detected! ' + window.web3);
      this.setShadowProvider();
    } else {
      window.addEventListener('load', () => {
        // console.log('Web3 Detect');
        if (typeof window.Web3 !== 'undefined') {
            // console.log('Web3 Detected! ' + Web3);
            this.setShadowProvider();
        }
      });
    }
  }

  getTransactionByUrlHash(hash: string) {
		return this.http.get(this.api_base_url + '/api/check-wallet-connect-request/' + hash,
		{headers: new HttpHeaders({'X-Requested-With': 'XMLHttpRequest'})});
	}

  saveWalletConnectTransaction (data) {
		return this.http.post(this.api_base_url + '/api/wallet-connect-response', data, {
			headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
		});
	}

  getAllPendingTransactions() {
    return this.http.get(this.api_base_url + '/api/user-wallet-connect-pending-request', {
			headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
		});
  }

  walletLoginCheck(data) { // input data: wallet, network
    return this.http.post(this.api_base_url + '/api/wallet-connect-login-check/v1', data, {
			headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
		}).pipe(catchError(error => {
      return throwError(error);
    }))
    .toPromise();
  }

  walletUserRegister(data) { // nput data: wallet, network, first_name, last_name, email
    return this.http.post(this.api_base_url + '/api/wallet-connect-login/v1' , data, {
			headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
		}).pipe(catchError(error => {
      return throwError(error);
    }))
    .toPromise();
  }

  walletLoginConnect(data) { // input data: wallet, signed
    return this.http.post(this.api_base_url + '/api/wallet-connect-login-connect' , data, {
			headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
		}).pipe(catchError(error => {
      return throwError(error);
    }))
    .toPromise();
  }

  walletLoginUnConnect(data) { // input data: wallet, signed
    return this.http.post(this.api_base_url + '/api/wallet-connect-login-unconnect' , data, {
			headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
		}).pipe(catchError(error => {
      return throwError(error);
    }))
    .toPromise();
  }

  walletAccounts() {
    this.authService.isTokenExist();
    return this.http.post(this.api_base_url + '/api/wallet-connect-accounts', {
			headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
		}).pipe(catchError(error => {
      return throwError(error);
    }))
    .toPromise();
  }

  async simplePrice(params?) {
    let response;
    await this.getCoinGecko(params).then(res => {
      response = res;
    }).catch(async () => {
      await this.coinCap(params).then(res => {
        // console.log('get coinCap', res);
        response = res;
      }).catch((error) => {
        console.log('get error', error);
        response = error;
      });
    });
    return response;
  }

  getCoinGecko(params = null) {
    let tx;
    params ? tx = params : tx = {ids: ['ethereum,binancecoin,binance-coin,bitcoin,matic-network,fantom,xdai,usdc,busd,tether'], vs_currencies: ['usd']}; // tx = {ids: ['ethereum', 'bitcoin'], vs_currencies: ['usd', "ils", "eur", "cad"]};
    const url = 'https://api.coingecko.com/api/v3';// https://api.coingecko.com/api/v3/simple/price?ids=<coin>&vs_currencies=usd
    return this.http.get(url + '/simple/price', {
      headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' }),
      params: tx
    })
    .pipe(
      map((response: any) => {
        return response;
      }),
      retryWhen(errors => {  // If response with error
        return errors
          .pipe(
            scan(acc => acc + 1, 0),
            takeWhile(acc => acc < 4), // 3 time repeat
            delayWhen(() => timer(5000)), // 5 s delay
            tap(() => console.log('retrying...'))
          );
      } ),
      catchError( error => {
        console.log('api.coingecko simplePrice error: ', error);
        return throwError(error);
    }))
    .toPromise();
  }

  // coinBaseRate() {
  //   const url = 'https://api.exchangerate.host/latest';
  //   return this.http.get(url + '/rates', {
  //     headers: new HttpHeaders(
  //       { 'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'Bearer 2aa4a3ae-4b70-41e0-9b00-644e9dbdce95' }
  //     )
  //   }).pipe(map(response => {
  //     console.log('coinBaseRate: ', response);
  //   }))
  //   .toPromise();
  // }

  coinCap(params: any = null) {
    let tx;
    params ? tx = params : tx = {ids: ['ethereum,binancecoin,binance-coin,bitcoin,matic-network,fantom,xdai,usdc,busd,tether'], vs_currencies: ['usd']};
    // const url = 'http://api.coincap.io/v2';
    const url = this.api_base_url + '/api/coincap';
    return this.http.get(url + '/rates', {
      headers: new HttpHeaders(
        {
        'X-Requested-With': 'XMLHttpRequest',
        // 'Authorization' : 'Bearer 5d34cae2-378c-423f-864c-ec1140e9ac59',
        }
      ),
    })
    .pipe(
      map((response: any) => {
        if (response && response.rates && response.rates.data) {
            let rate: any = {};
            let ids = tx.ids[0].split(',');
            let vs_currencies = tx.vs_currencies[0].split(',');
            // console.log('tx: ', ids, vs_currencies);

            ids.forEach(id => {
              vs_currencies.forEach(cur => {
                response.rates.data.forEach(value => {
                  if (value.id == id) {
                    rate[id] = {};
                    rate[id]['usd'] = value.rateUsd;
                  }
                  if (value.symbol == cur.toUpperCase()) {
                    rate[cur] = {};
                    rate[cur]['usd'] =  +value.rateUsd;
                  }
                });
              });
            });
            ids.forEach(id => {
              vs_currencies.forEach(cur => {
                Object.keys(rate).forEach(value => {
                  rate[cur]?.usd && rate[id]?.usd ? rate[id][cur] =  1/rate[cur]['usd']*rate[id]['usd'] : false;
                });
              });
            });
            // console.log('api.coincap.io value: ', response, rate);
            return rate;
          } else {
            console.log('Error: No data returned.');
            return null;
          }
      }),
      catchError( error => {
        console.log('api.coincap.io error: ', error);
        return throwError(error);
    }))
    .toPromise();
  }

  async refreshPriceData(currency) {
    const tx = {ids: ['ethereum,binancecoin,binance-coin,bitcoin,matic-network,fantom,xdai,usdc,busd,tether'], vs_currencies: currency !== 'usd' ? [currency+",usd"] : [currency]};
    const gasPrice: any = {};
    const simplePrice = await this.simplePrice(tx);
    // this.eventCurrency = currency; // simplePrice[this.networkIdName][currency];
    gasPrice.defaultGasPrice = await this.web3.eth.getGasPrice();
    return {simplePrice, gasPrice};
  }

  setProviderOptions() {
    if (window.WalletConnectProvider) {
      this.providerOptions = {
        // MyNetwork: { // test
        //   display: {
        //     logo: "../../assets/images/crypto/binance-logo.svg",
        //     // logo: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEyMCAxMDAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iNTQuMTk2IiB4Mj0iMTIwIiB5Mj0iNDUuODA0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMC4wNCIgc3RvcC1jb2xvcj0iIzAwOTZhNyIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuOTYiIHN0b3AtY29sb3I9IiNlZDM5NTIiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjEyMCIgaGVpZ2h0PSIxMDAiLz4KPC9zdmc+Cg==",
        //     name: "Web 3 My App",
        //     description: "Scan qrcode with your mobile wallet"
        //   },
        //   package: true,
        //   options: {
        //     appName: "Web 3 App",
        //     infuraId: this.walletProjectId, // this.walletInfuraId
        //   }
        // },
        // coinbasewallet: {
        //   package: CoinbaseWalletSDK,
        //   options: {
        //     // appName: "Web3 Get-in",
        //     infuraId: this.walletInfuraId, // this.walletProjectId,
        //   }
        // },

        walletconnect: {
          // display: {
          //   logo: "data:image/gif;base64,INSERT_BASE64_STRING",
          //   name: "Mobile",
          //   description: "Scan qrcode with your mobile wallet"
          // },
          package: WalletConnectProvider,
          options: {
            infuraId: this.walletInfuraId, // this.walletProjectId,
            // qrcodeModalOptions: {
            //   mobileLinks: ["rainbow", "metamask", "argent", "trust", "imtoken", "pillar", "trust", ],
            // },
          },
        },

        fortmatic: {
          package: this.Fortmatic,
          options: {
            key: this.fortmaticKey,
          },
        },

        // portis: {
        //   package: Portis,
        //   options: {
        //     id: this.portisId
        //   }
        // },

        // walletlink: { // Need to find correct js lib
        //   package: WalletLink,
        //   options: {
        //     appName: "MyGet-inApp",
        //     infuraUrl: 'https://mainnet.infura.io/v3/c0043db9d72846039b536bcf8612b718',
        //     infuraId: "c0043db9d72846039b536bcf8612b718", // Required unless you provide a JSON RPC url; see `rpc` below
        //     rpc: "https://mainnet.infura.io/v3/c0043db9d72846039b536bcf8612b718", // Optional if `infuraId` is provided; otherwise it's required
        //     chainId: 1, // Optional. It defaults to 1 if not provided
        //     appLogoUrl: null, // Optional. Application logo image URL. favicon is used if unspecified
        //     darkMode: false // Optional. Use dark theme, defaults to false
        //   },
        //   // logoUrl: 'https://logo-url-override/logo.png', // optional url to override logo
        // },

        // torus: { // Need to find correct js lib
        //   package: Torus, // required
        //   options: {
        //     networkParams: {
        //       host: "https://localhost:8545", // optional
        //       chainId: 1337, // optional
        //       networkId: 1337 // optional
        //     },
        //     config: {
        //       buildEnv: "development" // optional
        //     }
        //   }
        // },

        // binancechainwallet: { // working correctly
        //   display: {
        //     logo: "../../assets/images/crypto/binance-logo.svg",
        //     name: "Binance Chain Wallet",
        //     description: "Connect to your Binance Chain Wallet"
        //   },
        //   package: true,
        //   connector: async () => {
        //     let provider = null;
        //     if (typeof window.BinanceChain !== 'undefined') {
        //       provider = window.BinanceChain;
        //       try {
        //         await provider.request({ method: 'eth_requestAccounts' })
        //       } catch (error) {
        //         throw new Error("User Rejected");
        //       }
        //     } else {
        //       throw new Error("No Binance Chain Wallet found");
        //     }
        //     // console.log('binancechainwallet', provider);
        //     return provider;
        //   }
        // }
      };
      this.providerOptions['walletconnect'] = {
        // display: {
        //   logo: "data:image/gif;base64,INSERT_BASE64_STRING",
        //   name: "Mobile",
        //   description: "Scan qrcode with your mobile wallet"
        // },
        package: WalletConnectProvider,
        options: {
          infuraId: this.walletInfuraId, // this.walletProjectId,
          // qrcodeModalOptions: {
          //   mobileLinks: ["rainbow", "metamask", "argent", "trust", "imtoken", "pillar", "trust", ],
          // },
        },
      };

      this.createWeb3ModalInstance();
    }
  }

  createWeb3ModalInstance() {
    if (!this.Web3Modal) {return}
    this.web3Modal = new this.Web3Modal({
      network: "mainnet", // optional
      cacheProvider: false, // optional
      providerOptions: this.providerOptions, // required
      theme: {
        background: "rgb(39, 49, 56)",
        main: "rgb(199, 199, 199)",
        secondary: "rgb(136, 136, 136)",
        border: "rgba(195, 195, 195, 0.14)",
        hover: "rgb(16, 26, 32)"
      },
      disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
    });
    // console.log("Web3Modal instance is", this.web3Modal);
  }

  async setProvider() {
    // console.log('Opening a dialog to set provider:',  this.web3Modal, this.provider);
      try {
        if (this.provider && this.provider.selectedAddress) {
          // console.log('web3Modal.connected',);
          !!this.provider.isMetaMask ? this.provider = await this.web3Modal.connect() : false; // this.provider.isWalletConnect
        } else {
          this.provider = await this.web3Modal.connect();
          // console.log('web3Modal.connect', );

          this.hasProvider = true;
          // console.log('Provider is', this.provider, this.provider.isWalletConnect, this.provider.isMetaMask, this.provider.isCoinBase);

          this.provider.on("disconnect", (session) => {
            // console.log('Close', session);
            //Fire when closed QR code (or close the wallet connect session)
            this.walletSessionStatus.next('close');
          });

          this.provider.on("connect", (account) => {
            // console.log('Connect', account);
            // this.fetchAccountData();
          });

          // Subscribe to accounts change
          this.provider.on("accountsChanged", (accounts) => { this.accountChangedHandler(accounts); });

          // Subscribe to chainId change
          this.provider.on("chainChanged", (chainId) => { this.chainChangedHandler(chainId); });

          // Subscribe to networkId change
          this.provider.on("networkChanged", (networkId) => { this.networkChangedHandler(networkId); });

          this.provider.on("message", (message) => {
            // console.log('message: ', message);
          });

          this.provider.on("error", (error) => {
            console.log('error', error); // connection was close
            this.walletSessionStatus.next('close');
          });
          // console.log('web3Modal isMetaMask', this.provider.isMetaMask);
        }

        await this.refreshAccount();
        // console.log("Account was refreshed");
        this.walletSessionStatus.next('connected');
      } catch (error) {
        // this.hasProvider = false;
        console.log('Error: Provider has not been linked', this.provider, error);
        await this.web3Modal.clearCachedProvider();
        this.walletSessionStatus.next('disconnected');
      }
  }

  chainChangedHandler(chainId) {
    // TODO: If these changes will invoke errors need to reload the page // window.location.reload();
    // console.log('chainChanged', chainId);
    if (chainId) {
      this.fetchAccountData();
      this.walletSessionStatus.next('changeChain');
    } else {
      console.log('Doesn`t have any chainId'); // need to show error message
      this.walletSessionStatus.next('nodata');
      this.hasProvider = false;
      this.stopTimer();
    }
  }

  chainRemoveListener() {
    // console.log('chainRemoveListener');
    this.provider.removeListener("chainChanged", (chainId) => { this.chainChangedHandler(chainId); });
  }

  networkChangedHandler(networkId) {
    // TODO: If these changes will invoke errors need to reload the page // window.location.reload();
    console.log('networkChanged', networkId);
    if (networkId) {
      this.fetchAccountData();
      this.walletSessionStatus.next('changeNetwork');
    } else {
      console.log('Doesn`t have any networkId'); // need to show error message
      this.walletSessionStatus.next('nodata');
      this.hasProvider = false;
      this.stopTimer();
    }
  }

  networkRemoveListener() {
    // console.log('networkRemoveListener');
    this.provider.removeListener("networkChanged", (networkId) => { this.networkChangedHandler(networkId); });
  }

  accountChangedHandler(accounts) {
    // TODO: If these changes will invoke errors need to reload the page // window.location.reload();
    console.log('accountsChanged', accounts);
    if (accounts && accounts.length) {
      this.fetchAccountData();
      this.walletSessionStatus.next('changeAccount');
    } else {
      console.log('Doesn`t have any accounts'); // need to show error message
      this.walletSessionStatus.next('nodata');
      this.hasProvider = false;
      this.stopTimer();
    }
  }

  accountRemoveListener() {
    // console.log('accountRemoveListener');
    this.provider.removeListener("accountsChanged", (accounts) => { this.accountChangedHandler(accounts); });
  }

  async refreshAccount() {
    this.refreshAccountDataStatus.next(false);
    await this.fetchAccountData();
    this.refreshAccountDataStatus.next(true);
  }

  async closeProvider() {
    // console.log("Wallet Disconnecting..", this.provider);
    // TODO: Which providers have close method?
    if(this.provider.close) {
      // console.log("Wallet close");
      await this.provider.close();
      // If the cached provider is not cleared,
      // WalletConnect will default to the existing session
      // and does not allow to re-scan the QR code with a new wallet.
      await this.web3Modal.clearCachedProvider();
      this.walletSessionStatus.next('disconnected');
      // console.log('provider is closed', this.provider);
    } else if (this.provider.isConnecting) {
      // console.log("Wallet isConnecting");
    } else if (!this.provider.connected) {
      await this.web3Modal.clearCachedProvider();
      this.walletSessionStatus.next('disconnected');
      // console.log("Wallet allready disconnected", this.hasProvider, this.provider, this.web3Modal);
    }
  }

  async getBalance(accountData) {
    this.accountBalance = null;
    const accounts: any = [];
    const data: any = {};
    // Go through all accounts and get their ETH balance
    const dataResolvers = accountData.accounts.map(async (address) => {
      const balance = await this.web3.eth.getBalance(address);
      data['address'] = address;
      data['balance'] = balance.toString();
      // walletBalance is a BigNumber instance
      const walletBalance = this.web3.utils.fromWei(balance.toString(), "ether");
      const humanFriendlyBalance = parseFloat(walletBalance.toString()).toFixed(6);
      this.eventCurrency = accountData.eventCurrency;
      const tx = {ids: ['ethereum,binancecoin,binance-coin,bitcoin,matic-network,fantom,xdai,usdc,busd,tether'], vs_currencies: this.eventCurrency !== 'usd' ? [this.eventCurrency+",usd"] : [this.eventCurrency]};
      this.cryptoPrice = await this.simplePrice(tx);
      // console.log('cryptoPrice', this.eventCurrency, this.cryptoPrice);
      // TODO: Need to check supported currencies and show error if not supported
      let eventCurrency;
      if (this.cryptoPrice && this.cryptoPrice[this.networkIdName]) {
        eventCurrency = this.cryptoPrice[this.networkIdName][this.eventCurrency];
        // console.log('eventCurrency', eventCurrency, accountData.chainData.shortName, this.networkIdName);
        const balanceInUSD = parseFloat((this.cryptoPrice[this.networkIdName].usd * walletBalance).toString()).toFixed(2);
        data['balanceInEventCur'] = parseFloat((eventCurrency * walletBalance).toString()).toFixed(2);
        data['balanceInUSD'] = balanceInUSD;
        data['walletBalance'] = walletBalance;
        data['humanFriendlyBalance'] = humanFriendlyBalance;
        data['networkName'] = accountData.chainData.name;
        data['networkIdName'] = this.networkIdName;
        data['networkCurrencyName'] = accountData.chainData.shortName;
        accounts.push(data);
        // console.log('accountContainer', accounts);
      } else {
        // TODO: What need to do if coins do not have the rate???
        this.walleChainError.next('network');
        this.dialogService.alertsModal('cryptoCurrency', 'walletChainNotFound', 5000, false);
        console.log('This network and they currency is not support in WalletConnect', this.networkIdName);
      }
      return accounts;
    });
    this.accountBalance = accounts;

    await Promise.all(dataResolvers);
    return accounts;
  }

  async fetchAccountData() {
    let accountData: any = {};
    this.web3Modal.clearCachedProvider();
    // console.log('hasProvider', this.hasProvider, this.provider.isMetaMask);
    if (this.hasProvider) {
      this.web3 = new Web3(this.provider); // create web3 instance
      // console.log("Web3 instance is", this.web3);
      this.bigNumber = this.web3.utils.BN;
      // console.log('Web3 current provider is', this.web3.providers, this.web3.eth, this.web3.currentProvider.selectedProvider);
      // set the transaction confirmations blocks
      this.web3.eth.transactionConfirmationBlocks = this.transactionConfirmationBlocks = 1; // This defines the number of blocks it requires until a transaction is considered confirmed

      // set the transaction block timeout
      this.web3.eth.transactionBlockTimeout = 100; // This option defines the amount of new blocks it should wait until the first confirmation happens

      // this.web3.eth.transactionPollingTimeout = 1000; // (default: 750) This option defines the number of seconds Web3 will wait for a receipt which confirms that a transaction was mined

      accountData.chainId = await this.web3.eth.getChainId(); // Get connected chain id from Ethereum node
      // console.log('chainId: ', accountData.chainId);

      // Load chain information over an HTTP API
      try {
        accountData.chainData = await this.evmChains.getChain(accountData.chainId);
        // console.log('chainData: ', accountData.chainData, this.networkIdName);
        this.networkName = accountData.chainData.network;
      } catch (error) {
          console.log('EvmChains getChain error', error);
          this.walleChainError.next('network');
          this.dialogService.alertsModal('cryptoCurrency', 'walletChainNotFound', 5000, false);
        return;
      }

      if (accountData.chainId) {
        // console.log('check NetworkIdName', this.networkIdName);
        // TODO: What need to do if coins do not have the rate???
        let networkIdName = null;
        this.networkIds.forEach((network, i) => {
          if (network[accountData.chainId]) {
            this.networkIdName = accountData.networkIdName = networkIdName = network[accountData.chainId];
            // console.log('networkIds', i, networkIdName, network);
            // console.log('Got NetworkIdName', this.networkIdName);
          } else if (!networkIdName && this.networkIds.length-1 == i) {
            this.walleChainError.next('coin');
            this.networkIdName = accountData.networkIdName = accountData.chainData.shortName == 'bnb' ? 'binancecoin' : 'ethereum'; // set as default
            this.dialogService.alertsModal('cryptoCurrency', 'walletCoinNotSupport', 5000, false);
            console.log('networkIds not found', networkIdName);
          }
        });
      } else {
        // TODO: Need to show error and disconnect wallet.
        this.walleChainError.next('network');
        this.dialogService.alertsModal('cryptoCurrency', 'walletChainNotFound', 5000, false);
        console.log('Network not found!');
      }
      // console.log('NetworkIdName: ', this.networkIdName);

      accountData.networkId = await this.web3.eth.net.getId(); // Get Network Id
      // console.log('networkId: ', accountData.networkId, );

      accountData.accounts = await this.web3.eth.getAccounts(); // Get list of accounts of the connected wallet
      // MetaMask does not give you all accounts, only the selected account
      // console.log("Got accounts", accountData.accounts);

      accountData.defaultNonce = await this.web3.eth.getTransactionCount(accountData.accounts[0]);
      // console.log('getDefaultNonce', accountData.defaultNonce);

      const tx = {from: this.selectedAccount, to: this.getinWallet, data: "0x", value: "0x"};
      accountData.estimatedGas = await this.web3.eth.estimateGas(tx);
      // console.log('getEstimatedGas', accountData.estimatedGas);

      accountData.defaultGasPrice = await this.web3.eth.getGasPrice();
      // console.log('getDefaultGasPrice', accountData.defaultGasPrice);

      accountData.blockNumber = await this.web3.eth.getBlockNumber();
      // console.log('getBlockNumber', accountData.blockNumber);

      this.fetchAccountDataStatus.next(accountData);
    } else {
      console.log("No provider", this.provider);
      this.fetchAccountDataStatus.next(null);
    }
  }

  getShadowProvider(net = null, provider = null) {
    const network = net ? net : 'mainnet';
    let wss = `wss://${network}.infura.io/ws/v3/${this.walletInfuraId}`;
    let https = `https://${network}.infura.io/v3/${this.walletInfuraId}`;
    // TODO: add anoter providers for different networks
    if (provider && provider === 'bnb') {
      net !== 'mainnet' ? https = 'https://data-seed-prebsc-1-s1.binance.org:8545' : https = 'https://bsc-dataseed1.binance.org:443';
    }
    const myProviders = {wss, https };
    return myProviders;
  }

  setSecondProvider(selAccount?) {
    const options = {
      reconnect: {
          auto: true,
          delay: 5000, // ms
          maxAttempts: 5,
          onTimeout: false
      }
    };
    const network = this.networkName ? this.networkName : null;
    const myHtthsProvider = new Web3.providers.HttpProvider(this.getShadowProvider(network).https, options);
    const myWssProvider = new Web3.providers.WebsocketProvider(this.getShadowProvider(network).wss, options);

    // this.myWeb3 = new Web3(new Web3.providers.WebsocketProvider(this.setMyProvider(), options)); // create web3 instance
    this.shadowWeb3Wss = new Web3(myWssProvider);
    this.shadowWeb3Http = new Web3(myHtthsProvider);
    // console.log("my Web3 instances are", this.shadowWeb3Wss, this.shadowWeb3Http);

    const subscription = this.shadowWeb3Wss.eth.subscribe('pendingTransactions', (error, result) => {
        // console.log("pendingTransactions", error, result);
        if (error) {console.log('pendingTransactions', error);}
    })
    .on("data", async (transactionHash) => {
        const trn = await this.shadowWeb3Http.eth.getTransaction(transactionHash);
        // console.log('trn', trn);
        setTimeout(() => {this.unSetProvider(subscription);}, 3000);
        // .then((transaction) => {
        //   if (transaction && transaction.to) {
        //     console.log('transactionHash', transactionHash);
        //     setTimeout(() => {this.unSetProvider(subscription);}, 5000);
        //     if (transaction.to.toLowerCase() === selAccount) {
        //       console.log('transaction', transaction);
        //       this.unSetProvider(subscription);
        //     }
        //   }
        //     // createNode(transaction.from, transaction.to);
        // });
    })
    .on("changed", (changed)=> {
      console.log('pending transactions changed', changed);
    })
    .on("connected", (connected)=> {
      console.log('pending transactions connected', connected);
    })
    .on("error", (error) => {
      console.log('pending transactions error', error);
      setTimeout(() => {this.unSetProvider(subscription);},1000);
    });
  }

  unSetProvider(subscription) {
    subscription.unsubscribe((error, success) => {
      if(success) console.log('Successfully unsubscribed!', success);
      if (error) console.log('Error unsubscribe', error);
    });
  }

  async getPendingTransaction() { // only for local transactions
    return await this.web3.eth.subscribe('pendingTransactions');
  }

  getPendingTransactions(address) { // only for local transactions
    // console.log('getPendingTransactions...');
    this.tratsactionPending = this.web3.eth.subscribe('pendingTransactions', (error, result) => {
      if (error) console.log('pendingTransaction error', error);
      if (result) console.log('pendingTransaction', result);
    });
    this.tratsactionPending.on("data", (transaction) => {
      try {
        console.log('pending transactions', transaction);
      } catch (error) {
        console.log('pending transactions error', error);
      }
    });
    this.tratsactionPending.on("changed", (changed)=> {console.log('pending transactions changed', changed);});
    this.tratsactionPending.on("connected", (connected)=> {console.log('pending transactions connected', connected);});
    this.tratsactionPending.on("error", (error)=> {console.log('pending transactions error', error);});
    // console.log('tratsaction subscription', this.tratsactionPending);
  }

  unsubscribePendingTransactions() {
    if (this.tratsactionPending) {
      this.tratsactionPending.unsubscribe((error, success) => {
        if(success) console.log('Successfully unsubscribed!', success);
        if (error) console.log('Error unsubscribe', error);
      });
    }
  }

  // async getTransactionsByFilter() { // not a function
  //   return await this.web3.eth.filter({'fromBlock': 'latest', 'toBlock': 'pending'});
  // }

  // async getByFilter(param = 'pending') { // not a function
  //   return await this.web3.eth.filter(param);
  // }

  async transactionsByFilter(selAccount, param) {
    const accAddress = selAccount;
    await this.web3.eth.getBlock(param, async (error, blockHash) => {
      if (!error) {
        const block = await this.web3.eth.getBlock(blockHash, true);
        // console.log('transactions block', block);
        if (block && block.transactiions) {
          block.transactiions.forEach(trn => {
            if (accAddress == trn.from || accAddress == trn.to) {
              console.log('transactiion', trn);
            }
          });
        }
      }
    });
  }

  async getTransactionByHash(txHash) {
    return await this.web3.eth.getTransaction(txHash);
  }

  async getCoinBase() {
    return await this.web3.eth.getCoinbase(); // Returns the coinbase address to which mining rewards will go.
  }

  getMessage() {
    const msg: any = {};
    return msg;
  }

  async getPendingTransaction_() {
    return await this.web3.eth.getPendingTransactions();
  }

  async signMessage() {
    const msg = this.getMessage();
    // Sign Message
    const signedMessage = await this.web3.eth.sign(msg);
    return signedMessage;
  }

  async signTypedData() {
    const msg = this.getMessage();
    // Sign Typed Data
    const signedTypedData = await this.web3.eth.signTypedData(msg);
    return signedTypedData;
  }

  async signTransaction(tx) {
    return await this.web3.eth.signTransaction(tx);
  }

  async sendTransaction(tx) {
    return await this.web3.eth.sendTransaction(tx);
  }

  sendTransactions(tx) {
    return this.web3.eth.sendTransaction(tx);
  }

  async estimateGas(tx) {
    return await this.web3.eth.estimateGas(tx);
  }

  async getGasPrice() : Promise<number> {
    return await this.web3.eth.getGasPrice();
  }

  async getNonce(selectedAccount) {
    return await this.web3.eth.getTransactionCount(selectedAccount);
  }

  async getBlock(type) {
    return await this.web3.eth.getBlock(type, true);
  }

  stringToHex(mixed) {
    const value = this.web3.utils.toHex(mixed);
    // console.log('stringToHex', mixed );
    return value;
  }

  hexToNumberString(hexstr) {
    return this.web3.utils.hexToNumberString(hexstr);
  }

  setToWei(ether) {
    const value = this.web3.utils.toWei(ether, 'ether');
    // console.log('setToWei', value);
    return value;
  }

  setToGWei(ether) {
    const value = this.web3.utils.toWei(ether, 'Gwei');
    // console.log('setToGWei', value);
    return value;
  }

  getFromWei(wei) {
    const value = this.web3.utils.fromWei(wei, "ether");
    // console.log('getFromWei', value);
    return value;
  }

  getFromGWei(wei) {
    const value = this.web3.utils.fromWei(wei, "Gwei");
    // console.log('getFromGWei', value);
    return value;
  }

  toBN(bn) {
    const value = this.web3.utils.toBN(bn);
    return value;
  }

  getShadowFromWei(wei) {
    const value = this.shadowWeb3Http.utils.fromWei(wei, "ether");
    // console.log('getFromWei', value);
    return value;
  }

  getShadowFromGWei(wei) {
    const value = this.shadowWeb3Http.utils.fromWei(wei, "Gwei");
    // console.log('getFromGWei', value);
    return value;
  }

  getCurrentProvider() {
    const provider = this.web3.currentProvider;
    return provider;
  }

  async getStorageAt(selectedAccount) {
    // Get the value `val` from the contract's private storage
   return await this.web3.eth.getStorageAt(selectedAccount, 1);
  }

  startTimer(timerFire?: Function) {
    this.stopTimer();
    // console.log("Starting the timer");
    const timerStatus = interval(15000).subscribe(event => {
      // console.log('subscribe', event);
      this.refreshTimer.next(event);
      event >= 60 ? this.stopTimer() : null; // timerFire(event); // refresh until 15 minutes is up
    });
    this.timerSubscription.push(timerStatus);
  }

  stopTimer(): void {
    // console.log("Timer stopped");
    // this.timerSubscription ? this.timerSubscription.unsubscribe() : false;
    this.timerSubscription.forEach(subscription => subscription.unsubscribe());
  }

  checkStatus(txHash, state, data = null, response = null) {
    if (state !== 'confirmation') {
      this.checkTransactionStatus.next({txHash, state, event: 0, data, response});
    } else {
      const transactionStatus = interval(30000).subscribe(event => { // check status every half minute if transaction is pending
        // console.log('transaction Status subscribe event number is', event);
        this.checkTransactionStatus.next({txHash, state, event, data, response});
        event >= 120 ? this.stopCheckStatus() : null;
      });
      this.transactionSubscription.push(transactionStatus);
      // console.log('start check status', this.transactionSubscription.length);
    }
  }

  stopCheckStatus() {
    // console.log("Check status was stopped", this.transactionSubscription);
    // this.transactionSubscription ? this.transactionSubscription.unsubscribe() : false;
    this.transactionSubscription.forEach(subscription => subscription.unsubscribe());
  }

  shadowCheckPendingTransactionByUser() {
    // console.log("Start shadow checking...");
    if (this.user_id && this.user_id !== 0) {
      this.getAllPendingTransactions().subscribe((response: any) => {
        // this.getAuthirize();
        if (response.code === 'success') {
          if (response.data && response.data.length > 0) {
            // if data exists then detect web3 provider and start checking transactions
            if (environment.production) { // temporary checking
              response.data.forEach(transaction => {
                const networkName = transaction.transaction_data.network || null;
                const chain = transaction.transaction_data.chain_currency || null;
                this.pendingTransaction = {txHash: transaction.transaction_hash, state: 'pending', data: transaction.transaction_data, response: transaction};
                // console.log('Befor checkAndSetNetwork', networkName, chain);
                // this.startShadowCheckingTransaction(this.pendingTransaction);
                this.checkAndSetNetwork(this.pendingTransaction, networkName, chain);
              });
            } else {
              const networkName = response.data[0].transaction_data.network || null;
              const chain = response.data[0].transaction_data.chain_currency || null;
              this.pendingTransaction = {txHash: response.data[0].transaction_hash, state: 'pending', data: response.data[0].transaction_data, response: response.data[0]};
              // console.log('Befor checkAndSetNetwork', networkName, chain);
              // this.startShadowCheckingTransaction(this.pendingTransaction);
              this.checkAndSetNetwork(this.pendingTransaction, networkName, chain);
            }
            // console.log('start shadow checking Transaction', this.pendingTransaction);
          } else {
            // console.log('User do not have any pending transaction');
          }
        } else {
          console.log('Something went wrong...');
        }
      });
    } else {
      console.log('User not authorized yet, service will start lately');
    }
  }

  checkAndSetNetwork(pendingTransaction, network, chain) {
    this.setNetwork(network, chain).then(value => {
      if (value) {
        this.startShadowCheckingTransaction(pendingTransaction);
      }
    });
  }

  startShadowCheckingTransaction(pendingTransaction) { // transaction.transaction_hash, 'pending', transaction.transaction_data, transaction
    this.getShadowTransactionByHash(pendingTransaction.txHash).then(response => {
      // console.log('Shadow Got Transaction', response);
      if (response && response.blockHash && response.blockNumber) { // transaction status is success
        this.saveShadowTransaction(response, pendingTransaction.state, pendingTransaction.data, pendingTransaction.response); // save transaction data into DB
      } else if (response && !response.blockHash && !response.blockNumber) {
        console.log('Shadow Transaction Without BlockHash', response);
      } else {
        console.log('Shadow Transaction Logical problem... Transaction not found. Network or hash invalid.', response);
      }
    }).catch(error => {
      console.log('Shadow Get Pending Transaction error', error);
    });
  }

  saveShadowTransaction(txHash?, state?, transaction_data?, dbResponse?) {
    const res =  dbResponse && dbResponse.transaction_data ? dbResponse.transaction_data : false;
    // state && transaction_data ? txHash[state] = transaction_data : false;
    if (state && transaction_data) {
      this.prevStates.forEach(prev => {
        txHash[prev.state] = prev.data;
      });
      this.prevStates.push({state, data: transaction_data});
      txHash[state] = transaction_data;
    } else if (state === 'pending') {
      this.prevStates.push({state, data: txHash});
    }
    txHash.event_id = res && res.event_id ? res.event_id : '';
    txHash.event_name = res && res.event_name ?  res.event_name : '';
    txHash.total_tickets = res && res.total_tickets ?  res.total_tickets : '';
    txHash.user_email = res && res.user_email ?  res.user_email : '';
    txHash.chain_currency = res && res.chain_currency ?  res.chain_currency : '';
    txHash.transaction_amount = res && res.transaction_amount ?  res.transaction_amount : '';
    txHash.transaction_fee = res && res.transaction_fee ?  res.transaction_fee :  '';
    txHash.event_currency_rate = res && res.event_currency_rate ?  res.event_currency_rate : '';
    txHash.tickets_currency = res && res.tickets_currency ?  res.tickets_currency : '';
    txHash.tickets_price = res && res.tickets_price ?  res.tickets_price : '';
    txHash.tickets_price_without_fee = res && res.tickets_price_without_fee ?  res.tickets_price_without_fee : '';
    txHash.tickets_price_in_chain_cur_wo_fee = res && res.tickets_price_in_chain_cur_wo_fee ?  res.tickets_price_in_chain_cur_wo_fee : '';
    txHash.tickets_amount = res && res.tickets_amount ?  res.tickets_amount : '';
    txHash.usd_currency_rate = res && res.usd_currency_rate ?  res.usd_currency_rate : '';
    txHash.network =  res && res.network ?  res.network : '';

    const params = {
      payment_id: dbResponse && dbResponse.payment_id ? dbResponse.payment_id : '',
      transaction_hash: txHash.hash,
      transaction_status: 1,
      // transaction_amount: response && response.transaction_data.transaction_amount ?  response.transaction_data.transaction_amount : this.transactionData.ticketPriceTotal,
      // transaction_from: txHash.from,
      // transaction_to: txHash.to,
      transaction_data: txHash //{transaction_amount: this.transactionData.ticketPriceTotal, txHash}
    };
    // console.log('before shadow save transaction to back-end', params);
    this.saveWalletConnectTransaction(params).subscribe((response: any) => {
      // console.log('Shadow Save Transaction response', response);
      if (response.data && response.data.url) {
        // console.log('Shadow transaction saved successfully');
      } else if (response.code === 'success' && !response.data.success) {
        this.stopCheckStatus();
        // console.log('Shadow transaction saved as pending');
      } else {
        console.log('Shadow transaction save to DB Error', response.code);
      }
    });
  }

  async setNetwork(network = null, chain = null) {
    // console.log('setNetwork: ', this.networkName, network, chain);
    // this.networkName = network;
    const options = {reconnect: {auto: true, delay: 5000, maxAttempts: 5, onTimeout: true}};
    const myHtthsProvider = new Web3.providers.HttpProvider(this.getShadowProvider(network, chain).https, options);
    this.shadowWeb3Http = new Web3(myHtthsProvider);
    // console.log("Shadow Web3 instance is", this.shadowWeb3Http);
    return await this.shadowWeb3Http ? true : false;
  }

  async setNewProvider() {
      const network = this.networkName ? this.networkName : null;
      const options = {reconnect: {auto: true, delay: 5000, maxAttempts: 5, onTimeout: true}};
      const myHtthsProvider = new Web3.providers.HttpProvider(this.getShadowProvider(network).https, options);
      this.shadowWeb3Http = new Web3(myHtthsProvider);
      // console.log("Shadow Web3 instance is", this.shadowWeb3Http);
      return await this.shadowWeb3Http ? true : false;
  }

  setShadowProvider(net = null, provider = null) {
    if (Web3) { // && !this.shadowWeb3Http
      if (this.networkName !== net) {
        let network;
        net ? network = net : this.networkName ? network = this.networkName : network = null;
        const options = {reconnect: {auto: true, delay: 5000, maxAttempts: 5, onTimeout: true}};
        const myHtthsProvider = new Web3.providers.HttpProvider(this.getShadowProvider(network, provider).https, options);
        // const myWssProvider = new Web3.providers.WebsocketProvider(this.getShadowProvider(network).wss, options);
        // this.shadowWeb3Wss = new Web3(myWssProvider);
        this.shadowWeb3Http = new Web3(myHtthsProvider);
      }
      // console.log("Shadow Web3 instances are", this.networkName, net, provider, this.shadowWeb3Wss, this.shadowWeb3Http);
      this.shadowCheckPendingTransactionByUser();
    } else {
      console.log('Web3 provider has not been installed! No further operations possible!');
    }
  }

  async getShadowTransactionByHash(txHash) {
    return await this.shadowWeb3Http.eth.getTransaction(txHash);
  }

  async getPublicAddress(provider) {
    const coinbase = await provider.eth.getCoinbase();
    // console.log('getPublicAddress coinbase', coinbase);
    return coinbase; // await provider.eth.getAccounts(); // Get list of accounts of the connected wallet
  }

  async backendCheckUserAddress(provider, addr) {
    return new Promise(resolve => {
      setTimeout(() => {
        const generatedNonce = Math.floor(Math.random() * 100000000).toString();
        resolve(generatedNonce);
        // resolve(provider.utils.utf8ToHex(generatedNonce));
      }, 2000);
    });
  }

  async personalSign(provider, nonce, addr) {
    // return await provider.eth.personal.sign(`Get-in Authentication id: ${nonce} \nAddress: ${addr}`, addr, '');
    // console.log(`Get-in Authentication id: ${nonce}`);
    return await provider.eth.personal.sign(`Get-in Authentication id: ${nonce}`, addr, '');
  }

  async checkSignature(provider, dataSigned, nonce, addr) {
    // const testSignedData = await provider.eth.personal.ecRecover(`Get-in Authentication id: ${nonce} \nAddress: ${addr}`, dataSigned);
    const testSignedData = await provider.eth.personal.ecRecover(`Get-in Authentication id: ${nonce}`, dataSigned);
    return testSignedData;
  }

  async getProvider() {
    let provider;
    try {
      await this.web3Modal.clearCachedProvider();
      provider = await this.web3Modal.connect();
      // console.log("New Provider: ", provider, this.web3Modal.cachedProvider);
      provider.on("connect", (account) => {
        console.log('Connect', account);
        // this.fetchAccountData();
      });
      provider.on("message", (message) => {
        console.log('message: ', message);
      });
      provider.on("disconnect", (session) => {
        console.log('Close', session);
        //Fire when closed QR code (or close the wallet connect session)
      });
      provider.on("error", (error) => {
        console.log('error', error); // connection was close
        this.web3Modal.clearCachedProvider();
      });
    } catch (error) {
      console.log("provider not enabled", error);
      if(!this.web3Modal) {return }
      await this.web3Modal.clearCachedProvider();
      if (error.toString().includes('closed')) {
        this.walletConnectUser.next({errors: 5, connected: 0, error});
      } else if (error.toString().includes('denied')) {
        this.walletConnectUser.next({errors: 7, connected: 0, error});
      } else {
        this.walletConnectUser.next({errors: 6, connected: 0, error});
      }
      return;
    }
  // provider.enable().then(value => {
  //   console.log("provider.enable", value);
  // });
  // console.log("New provider is", provider, provider.isWalletConnect, provider.isMetaMask, provider.isCoinBase);
  await this.web3Modal.clearCachedProvider();
  return provider;
  }

  async waletAuthorization(unConnectWallet = null, connectWallet = false, userData = null, checked=false, address = '') {
    if (userData && userData.otp_code && this.otpWalletAddress && (this.walletIsChecked || checked) ) {
      console.log('waletAuthorization with OTP', address, userData);
      userData['wallet'] = this.otpWalletAddress.toLowerCase();
      this.walletUserSignup(userData);
      return;
    }
    console.log('waletAuthorization check address', this.walletIsChecked, this.otpWalletAddress, userData);
    let provider = null;
    localStorage.removeItem('walletconnect');
    console.log("waletAuthorization", provider, this.web3Modal, unConnectWallet, connectWallet, userData);
    /** -------------------- */
    provider = await this.getProvider();
    const web3provider = new Web3(provider);
    /** --------------------- */
    // const chainId = await web3provider.eth.getChainId(); // Get connected chain id from Ethereum node
    console.log('provider: ', provider, web3provider);
    if (provider) {
      this.getPublicAddress(web3provider).then(address => {
        console.log('getPublicAddress', address);
        if (address) {
          // check address in DB
          this.otpWalletAddress = address;
          this.otpProvider = provider;
          this.otpWeb3provider = web3provider;
          // address, provider, web3provider, unConnectWallet, connectWallet, userData
          this.checkWallet(address, provider, web3provider, unConnectWallet, connectWallet, userData);
          return;

          // Only For local test
          // this.backendCheckUserAddress(web3provider, address.toLowerCase()).then( nonce => {
          //   console.log('checkUserAddress', nonce);
          //   if (nonce) {
          //     this.personalSign(web3provider, nonce, address.toLowerCase()).then(async (signature) => {
          //       console.log('personalSign', signature);
          //       const testSignedData = await this.checkSignature(web3provider, signature, nonce, address.toLowerCase());
          //       const isLoggedin = address.toLowerCase() == testSignedData.toLowerCase();
          //       console.log('testSignedData: ', testSignedData, 'User was authorized: ', isLoggedin);
          //     }).catch(error => {
          //       console.log('personalSign error: ', error);
          //       this.walletConnectUser.next({errors: 1, connected: 0, error});
          //       if(provider.close) {
          //         console.log("Wallet close");
          //         provider.close();
          //         return;
          //       }
          //     });
          //   }
          // });
        }
      });
    }
  }

  checkWallet(address, provider, web3provider, unConnectWallet, connectWallet, userData) {
    this.walletLoginCheck({wallet: address.toLowerCase()}).then((response: any) => {
      console.log('walletLoginCheck response: ', response);
      console.log('walletLoginCheck checkWallet: ', address, provider, web3provider, unConnectWallet, connectWallet, userData);
      if (!unConnectWallet && !connectWallet && !userData) {
        if (response.code === 'success' && response.data && response.data.check) {
          // console.log('User exists', response); // response.data.nonce
          if (response.data && response.data.nonce) {
            // TODO: Need to send user data back to authorize
            this.walletConnectUser.next({errors: 0, connected: 0, response});
            this.personalSign(web3provider, response.data.nonce, address.toLowerCase()).then(async (signature) => {
              console.log('personalSign', signature);
              // TODO: Need to send user signature to backend
              this.walletUserConnect({wallet: address.toLowerCase(), signed: signature});
              // TODO: Need to send user data back to confirm in wallet
              // this.walletConnectUser.next({errors: 0, connected: 0, response});
            }).catch(error => {
              console.log('personalSign error: ', error);
              this.walletConnectUser.next({errors: 1, connected: 0, error});
              if(provider.close) {
                console.log("Wallet close");
                provider.close();
                return;
              }
            });
          }
        } else if (response.code === 'success' && response.data && !response.data.check) {
          console.log('User wallet not exists, need/may to register and check his email or phone', response);
          response['currentWallet'] = address.toLowerCase();
          this.walletConnectUser.next({errors: 4, connected: 0, response}); // The wallet not registered
          // the wallet can be registered
          // this.walletIsChecked = true;
        }
      } else if (unConnectWallet) {
        if (response.code === 'success' && response.data && response.data.check) {
          if (address.toLowerCase() == unConnectWallet.wallet.toLowerCase()) {
            this.personalSign(web3provider, unConnectWallet.nonce, unConnectWallet.wallet.toLowerCase()).then(async (signature) => {
              console.log('personalSign unConnectWallet', signature);
              // TODO: Need to send user data back to authorize
              this.walletUnConnect.next(signature);
            }).catch(error => {
              console.log('personalSign unConnectWallet error: ', error);
              this.walletConnectUser.next({errors: 1, connected: 0, error});
              if(provider.close) {
                console.log("Wallet close");
                provider.close();
                return;
              }
            });
          } else if (address.toLowerCase() !== unConnectWallet.wallet.toLowerCase()) {
            // send back message that user wallet not the same that user wants to remove
            console.log('User wallet not the same that user wants to remove', address, unConnectWallet.wallet);
          }
        } else if (response.code === 'success' && response.data && !response.data.check) {
          console.log('Connected wallet not registered');
        }
      } else if (connectWallet) {
        if (response.code === 'success' && response.data && response.data.check) {
          // console.log('Connected wallet already used');
          this.walletConnectUser.next({errors: 4.1, connected: 0, response});
          // return error
        } else if (response.code === 'success' && response.data && !response.data.check) {
          // If wallet not found we will add wallet to the current user
          this.backendCheckUserAddress(web3provider, address.toLowerCase()).then( nonce => {
            // console.log('checkUserAddress', nonce);
            this.personalSign(web3provider, nonce, address.toLowerCase()).then(async (signature) => {
              // console.log('personalSign connectWallet', signature);
              const testSignedData = await this.checkSignature(web3provider, signature, nonce, address.toLowerCase());
              const isSame = address.toLowerCase() == testSignedData.toLowerCase();
              if (isSame) {
                // TODO: Need to send user data back
                response['wallet'] = address.toLowerCase();
                this.walletConnectUser.next({errors: 0, connected: 1, response});
              }
            }).catch(error => {
              console.log('personalSign connectWallet error: ', error);
              this.walletConnectUser.next({errors: 1, connected: 0, error});
              if(provider.close) {
                console.log("Wallet close");
                provider.close();
                return;
              }
            });
          });
        }
      } else if (userData) {
        if (response.code === 'success' && response.data && response.data.check) {
          console.log('Connected wallet already used');
          this.walletConnectUser.next({errors: 2, connected: 0, response});
        } else  if (response.code === 'success' && response.data && !response.data.check) {
          console.log('User wallet not exists, need/may to register and check his email', response);
          this.walletIsChecked = true;
          userData['wallet'] = address.toLowerCase();
          this.walletConnectUser.next({errors: 0, connected: 0, response, check: true, address: address.toLowerCase()});
          this.walletUserSignup(userData);
        }
      }

    }).catch(error => {
      console.log('error: ', error);
      this.walletConnectUser.next({errors: 1, connected: 0, error});
    });
  }

  walletUserSignup(userData) {
    console.log('walletUserSignup', userData); // {email, phone, phone_country_code, otp_code} + {wallet}
    this.recaptchaService.execute('LOGIN').then(token => {
      const data = {wallet: userData.wallet,  email: userData.email, phone: userData.phone, phone_country_code: userData.phone_country_code, otp_code: userData.otp_code, 'g-recaptcha-response': token}; // first_name: userData.first_name, last_name: userData.last_name,
      console.log('walletUser send data: ', data);
      this.walletUserSignin(data).then((response: any) => {
        if (response) {
          console.log('walletUserRegistration response: ', response);
          if (response.code == 100) {
            console.log('The User already registered!');
            userData.email ? this.walletConnectUser.next({errors: 3, connected: 0, response}) : this.walletConnectUser.next({errors: 3.1, connected: 0, response});
          } else if (response.code == 42) {
            this.walletConnectUser.next({errors: 42, connected: 0, response});
          } else if (response.code == 'success') {
            this.walletConnectUser.next({errors: 8, connected: 0, response});
            console.log('OTP code was sent, please enter the code');
          } else if (response && response.original && response.original.error == 37) {
            console.log('Requests sending too often!');
            this.walletConnectUser.next({errors: 10, connected: 0, response});
          } else {
            this.walletConnectUser.next({errors: 0, connected: 1, response});
            if (userData && userData.otp_code) {
              this.otpWalletAddress = '';
              this.otpWeb3provider = null;
              this.otpProvider = null;
              this.walletIsChecked = false;
            }
          }
        }
      }).catch(error => {
        console.log('walletUserRegister error: ', error);
        if (error && error.code == 35) {
          this.walletConnectUser.next({errors: 9, connected: 0, response: error});
        } else if (error && error.code == 37) {
          this.walletConnectUser.next({errors: 10, connected: 0, response: error});
        } else if (error && error.code == 40) {
          this.walletConnectUser.next({errors: 11, connected: 0, error});
        } else if (error && error.code == 42) {
          this.walletConnectUser.next({errors: 42, connected: 0, response: error});
        } else if (error && error.code == 43) {
          this.walletConnectUser.next({errors: 43, connected: 0, response: error});
        } else if (error && error.code == 44) {
          this.walletConnectUser.next({errors: 44, connected: 0, response: error});
        } else if (error && error.code == 45) {
          this.walletConnectUser.next({errors: 45, connected: 0, response: error});
        } else {
          this.walletConnectUser.next({errors: 1, connected: 0, error});
        }

      });
    });

  }


  walletUserSignin(data) {
    return this.walletUserRegister(data);
    // .then(response => {
    //   if (response) {
    //     console.log('walletUserRegistration User was registered!', response);
    //     // TODO: Need to send user data back to authorize
    //     this.walletConnectUser.next({errors: 0, connected: 0, response});
    //   }
    // }).catch(error => {
    //   console.log('walletUserRegister error: ', error);
    //   this.walletConnectUser.next({errors: 1, connected: 0, error});
    // });
  }

  walletUserConnect(data) {
    this.recaptchaService.execute('LOGIN').then(token => {
      const new_data = {...data,
        'g-recaptcha-response': token
      };
      console.log('walletUser send data 2: ', new_data);
      this.walletUserSignin(new_data).then((response: any) => {
        if (response) {
          console.log('walletLoginConnect User already connected his wallet!', response);
          response['wallet'] = data.wallet;
          // TODO: Need to send user data back to show message
          this.walletConnectUser.next({errors: 0, connected: 1, response});
        }
      }).catch(error => {
        console.log('walletLoginConnect error: ', error);
        if (error && error.code == 40) {
          console.log('User registration server errorr.');
          this.walletConnectUser.next({errors: 11, connected: 0, error});
        } else if (error.httpStatus === 400) {
          // Need to show error that the wallet is already used
          console.log('The wallet is already used');
          this.walletConnectUser.next({errors: 1, connected: 0, error});
        }
      });
    });

  }

  // contract() {
    // var V3_pool_ABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"int24","name":"tickLower","type":"int24"},{"indexed":true,"internalType":"int24","name":"tickUpper","type":"int24"},{"indexed":false,"internalType":"uint128","name":"amount","type":"uint128"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"address","name":"recipient","type":"address"},{"indexed":true,"internalType":"int24","name":"tickLower","type":"int24"},{"indexed":true,"internalType":"int24","name":"tickUpper","type":"int24"},{"indexed":false,"internalType":"uint128","name":"amount0","type":"uint128"},{"indexed":false,"internalType":"uint128","name":"amount1","type":"uint128"}],"name":"Collect","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":true,"internalType":"address","name":"recipient","type":"address"},{"indexed":false,"internalType":"uint128","name":"amount0","type":"uint128"},{"indexed":false,"internalType":"uint128","name":"amount1","type":"uint128"}],"name":"CollectProtocol","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":true,"internalType":"address","name":"recipient","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"paid0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"paid1","type":"uint256"}],"name":"Flash","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint16","name":"observationCardinalityNextOld","type":"uint16"},{"indexed":false,"internalType":"uint16","name":"observationCardinalityNextNew","type":"uint16"}],"name":"IncreaseObservationCardinalityNext","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint160","name":"sqrtPriceX96","type":"uint160"},{"indexed":false,"internalType":"int24","name":"tick","type":"int24"}],"name":"Initialize","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"sender","type":"address"},{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"int24","name":"tickLower","type":"int24"},{"indexed":true,"internalType":"int24","name":"tickUpper","type":"int24"},{"indexed":false,"internalType":"uint128","name":"amount","type":"uint128"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"feeProtocol0Old","type":"uint8"},{"indexed":false,"internalType":"uint8","name":"feeProtocol1Old","type":"uint8"},{"indexed":false,"internalType":"uint8","name":"feeProtocol0New","type":"uint8"},{"indexed":false,"internalType":"uint8","name":"feeProtocol1New","type":"uint8"}],"name":"SetFeeProtocol","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":true,"internalType":"address","name":"recipient","type":"address"},{"indexed":false,"internalType":"int256","name":"amount0","type":"int256"},{"indexed":false,"internalType":"int256","name":"amount1","type":"int256"},{"indexed":false,"internalType":"uint160","name":"sqrtPriceX96","type":"uint160"},{"indexed":false,"internalType":"uint128","name":"liquidity","type":"uint128"},{"indexed":false,"internalType":"int24","name":"tick","type":"int24"}],"name":"Swap","type":"event"},{"inputs":[{"internalType":"int24","name":"tickLower","type":"int24"},{"internalType":"int24","name":"tickUpper","type":"int24"},{"internalType":"uint128","name":"amount","type":"uint128"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"int24","name":"tickLower","type":"int24"},{"internalType":"int24","name":"tickUpper","type":"int24"},{"internalType":"uint128","name":"amount0Requested","type":"uint128"},{"internalType":"uint128","name":"amount1Requested","type":"uint128"}],"name":"collect","outputs":[{"internalType":"uint128","name":"amount0","type":"uint128"},{"internalType":"uint128","name":"amount1","type":"uint128"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint128","name":"amount0Requested","type":"uint128"},{"internalType":"uint128","name":"amount1Requested","type":"uint128"}],"name":"collectProtocol","outputs":[{"internalType":"uint128","name":"amount0","type":"uint128"},{"internalType":"uint128","name":"amount1","type":"uint128"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"fee","outputs":[{"internalType":"uint24","name":"","type":"uint24"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"feeGrowthGlobal0X128","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"feeGrowthGlobal1X128","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"flash","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"observationCardinalityNext","type":"uint16"}],"name":"increaseObservationCardinalityNext","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint160","name":"sqrtPriceX96","type":"uint160"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"liquidity","outputs":[{"internalType":"uint128","name":"","type":"uint128"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxLiquidityPerTick","outputs":[{"internalType":"uint128","name":"","type":"uint128"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"int24","name":"tickLower","type":"int24"},{"internalType":"int24","name":"tickUpper","type":"int24"},{"internalType":"uint128","name":"amount","type":"uint128"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"mint","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"observations","outputs":[{"internalType":"uint32","name":"blockTimestamp","type":"uint32"},{"internalType":"int56","name":"tickCumulative","type":"int56"},{"internalType":"uint160","name":"secondsPerLiquidityCumulativeX128","type":"uint160"},{"internalType":"bool","name":"initialized","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint32[]","name":"secondsAgos","type":"uint32[]"}],"name":"observe","outputs":[{"internalType":"int56[]","name":"tickCumulatives","type":"int56[]"},{"internalType":"uint160[]","name":"secondsPerLiquidityCumulativeX128s","type":"uint160[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"name":"positions","outputs":[{"internalType":"uint128","name":"liquidity","type":"uint128"},{"internalType":"uint256","name":"feeGrowthInside0LastX128","type":"uint256"},{"internalType":"uint256","name":"feeGrowthInside1LastX128","type":"uint256"},{"internalType":"uint128","name":"tokensOwed0","type":"uint128"},{"internalType":"uint128","name":"tokensOwed1","type":"uint128"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFees","outputs":[{"internalType":"uint128","name":"token0","type":"uint128"},{"internalType":"uint128","name":"token1","type":"uint128"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint8","name":"feeProtocol0","type":"uint8"},{"internalType":"uint8","name":"feeProtocol1","type":"uint8"}],"name":"setFeeProtocol","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"slot0","outputs":[{"internalType":"uint160","name":"sqrtPriceX96","type":"uint160"},{"internalType":"int24","name":"tick","type":"int24"},{"internalType":"uint16","name":"observationIndex","type":"uint16"},{"internalType":"uint16","name":"observationCardinality","type":"uint16"},{"internalType":"uint16","name":"observationCardinalityNext","type":"uint16"},{"internalType":"uint8","name":"feeProtocol","type":"uint8"},{"internalType":"bool","name":"unlocked","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"int24","name":"tickLower","type":"int24"},{"internalType":"int24","name":"tickUpper","type":"int24"}],"name":"snapshotCumulativesInside","outputs":
    // [{"internalType":"int56","name":"tickCumulativeInside","type":"int56"},{"internalType":"uint160","name":"secondsPerLiquidityInsideX128","type":"uint160"},{"internalType":"uint32","name":"secondsInside","type":"uint32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"bool","name":"zeroForOne","type":"bool"},{"internalType":"int256","name":"amountSpecified","type":"int256"},{"internalType":"uint160","name":"sqrtPriceLimitX96","type":"uint160"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[{"internalType":"int256","name":"amount0","type":"int256"},{"internalType":"int256","name":"amount1","type":"int256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"int16","name":"","type":"int16"}],"name":"tickBitmap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tickSpacing","outputs":[{"internalType":"int24","name":"","type":"int24"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"int24","name":"","type":"int24"}],"name":"ticks","outputs":[{"internalType":"uint128","name":"liquidityGross","type":"uint128"},{"internalType":"int128","name":"liquidityNet","type":"int128"},{"internalType":"uint256","name":"feeGrowthOutside0X128","type":"uint256"},{"internalType":"uint256","name":"feeGrowthOutside1X128","type":"uint256"},{"internalType":"int56","name":"tickCumulativeOutside","type":"int56"},{"internalType":"uint160","name":"secondsPerLiquidityOutsideX128","type":"uint160"},{"internalType":"uint32","name":"secondsOutside","type":"uint32"},{"internalType":"bool","name":"initialized","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}];
    // const V3InterfaceABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint24","name":"fee","type":"uint24"},{"indexed":true,"internalType":"int24","name":"tickSpacing","type":"int24"}],"name":"FeeAmountEnabled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"oldOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnerChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"token0","type":"address"},{"indexed":true,"internalType":"address","name":"token1","type":"address"},{"indexed":true,"internalType":"uint24","name":"fee","type":"uint24"},{"indexed":false,"internalType":"int24","name":"tickSpacing","type":"int24"},{"indexed":false,"internalType":"address","name":"pool","type":"address"}],"name":"PoolCreated","type":"event"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"}],"name":"createPool","outputs":[{"internalType":"address","name":"pool","type":"address"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"int24","name":"tickSpacing","type":"int24"}],"name":"enableFeeAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint24","name":"","type":"uint24"}],"name":"feeAmountTickSpacing","outputs":[{"internalType":"int24","name":"","type":"int24"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint24","name":"","type":"uint24"}],"name":"getPool","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"parameters","outputs":[{"internalType":"address","name":"factory","type":"address"},{"internalType":"address","name":"token0","type":"address"},{"internalType":"address","name":"token1","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"int24","name":"tickSpacing","type":"int24"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"setOwner","outputs":[],"stateMutability":"nonpayable","type":"function"}];
    // const factoryV3 = new this.web3.eth.Contract(V3InterfaceABI, '0x1F98431c8aD98523631AE4a59f267346ea31F984');

    // const addrETHtoUSD = "0x9326BFA02ADD2366b30bacB125260Af641031331"
    // const aggregatorV3InterfaceABI = [{ "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "description", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint80", "name": "_roundId", "type": "uint80" }], "name": "getRoundData", "outputs": [{ "internalType": "uint80", "name": "roundId", "type": "uint80" }, { "internalType": "int256", "name": "answer", "type": "int256" }, { "internalType": "uint256", "name": "startedAt", "type": "uint256" }, { "internalType": "uint256", "name": "updatedAt", "type": "uint256" }, { "internalType": "uint80", "name": "answeredInRound", "type": "uint80" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "latestRoundData", "outputs": [{ "internalType": "uint80", "name": "roundId", "type": "uint80" }, { "internalType": "int256", "name": "answer", "type": "int256" }, { "internalType": "uint256", "name": "startedAt", "type": "uint256" }, { "internalType": "uint256", "name": "updatedAt", "type": "uint256" }, { "internalType": "uint80", "name": "answeredInRound", "type": "uint80" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "version", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }];
    // const priceFeed = new this.web3.eth.Contract(aggregatorV3InterfaceABI, addrETHtoUSD)
    // priceFeed.methods.latestRoundData().call()
    //     .then((roundData) => {
    //         // Do something with roundData
    //         console.log("Latest Round Data", roundData);
    // });
  // }

  getFormatedWalletAddress(address) {
    const formatedAddress = address.substring(0, 5) + '..........' + address.substring(address.length - 5, 5);
    return formatedAddress;
  }

  checkNftScanParticipant(apply_ids = []) {
    return this.http.post(this.api_base_url + '/api/check-nft-scan-participant', {applies_id: apply_ids}, {
    headers: new HttpHeaders({'X-Requested-With': 'XMLHttpRequest', 'x-api-key': this.authService.getReaderApiKey()})
    });
  }

  checkNftScanParticipantTimer(apply_ids) {
    const timer = this.checkNftScanParticipant(apply_ids).subscribe(res => {
        this.NftScanParticipantData.next(res);
       // this.unsubscribeNftScanParticipant();
      }, error => {
        console.log('checkNftScanParticipant error', error);
        if (error.error === 4.1 || error.error === 4.3 || error.error === 18.4 || error.error === 18.5) {
          this.authService.removeReaderApiKeyAndId();
          this.dialogService.alertsModal('tokenErr', error.error,5000,false);
          setTimeout(() => { window.location.reload() }, 4000);
        }
    });
    this.NftScanParticipantSubscription.push(timer);
  }

  setPaytweedWallets(wallets = []) {
    // "wallets": [
    //   {"wallet": "faf", "network": "af"},
    //   {"wallet": "2", "network": "2"}
    // ]
    return this.http.post(this.api_base_url + '/api/paytweed/wallets', {wallets}, {
      headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
    });
  }

  getPaytweedAddress() {
    return this.http.get(this.api_base_url + '/api/paytweed/wallets',
      {headers: new HttpHeaders({'X-Requested-With': 'XMLHttpRequest'})});
  }

  failOnCreatePaytweed(main_purchase_identifier) {
    return this.http.post(this.api_base_url + '/api/paytweed/fail-create-wallets', {main_purchase_identifier}, {
      headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
    });
  }

  checkPaytweedWallets(hash) {
    return this.http.post(this.api_base_url + '/api/paytweed/check-paytweed-wallets/'+hash,  {
      headers: new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' })
    });
  }

  unsubscribeNftScanParticipant() {
    this.NftScanParticipantSubscription.forEach(subscription => subscription.unsubscribe());
  }

}
